<template>
  <div>
    <div class="selector-header mt-4 ml-4">
      <p class="kit-selector-label">{{ deliveryMethodName }}</p>
      <div>
        <TestSampleTypeTagNew
          v-for="name in sampleTypes"
          :key="name"
          :type="name"
          class="ml-1"
        />
      </div>
    </div>
    <el-select 
      :id="selectorId"
      v-model="value" 
      class="order-test order-summary-selector delivery mt-2" 
      :placeholder="$t('OrderPage[\'Select delivery method\']')"
      :disabled="disabled || isAddOnOrder.length > 0"
      @change="handleChange"
    >
      <el-option
        v-for="item in deliveryOptions"
        id="blood-selector-option"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>

  </div>
</template>

<script>
import TestSampleTypeTagNew from '@/views/va-orderTest/components/TestSampleTypeTag.vue';
import { mapState } from "vuex";
const DELIVERY_I18N = {
  shipToPatient: 'OrderPage["Ship to patient"]',
  suppliedByClient: 'OrderPage["Supplied by Client/Office/Phlebotomist"]',
};

export default {
  components: {
    TestSampleTypeTagNew,
  },
  props: {
    deliveryMethodName: {
      type: String,
      default: ""
    },
    sampleTypes: {
      type: Array,
      default: () => []
    },
    selectorId: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    deliveryValue: {
      type: String,
      default: ""
    }
  },
  emits: ["change"],
  data() {
    return {
      value: this.deliveryValue,
      deliveryOptions: [
        {
          value: "shipToPatient",
          label: this.$t(DELIVERY_I18N.shipToPatient),
        },
        {
          value: "suppliedByClient",
          label: this.$t(DELIVERY_I18N.suppliedByClient),
        },
      ]
    }
  },

  computed: {
    ...mapState("orderTest", ["isAddOnOrder"]),
    ...mapState("orderTest/user", ["userInfo"]),
  },

  watch: {
    deliveryValue(newVal) {
      this.value = newVal;
    },
    '$i18n.locale'() {
      this.deliveryOptions = this.deliveryOptions.map(opt => ({
        ...opt,
        label: this.$t(DELIVERY_I18N[opt.value]),
      }));
      this.$forceUpdate();
    },
  },
  methods: {
    handleChange(value) {
      this.$emit("change", value);
    },
  }
}
</script>

<style scoped>
.kit-selector-label {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.4004px;
}
.selector-header {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
</style>